var exports = {
  "k": "x805b157e--ff8527--container",
};

module.exports = exports;
